import { normalizeChatV2Progress } from './chatV2ProgressUtils';

const comparableText = (value) => typeof value === 'string'
    ? value.trim().toLowerCase().replace(/\s+/g, ' ').replace(/[.!?]+$/, '') : '';

export const chatRequestFailed = (run) => {
    const progress = normalizeChatV2Progress(run?.progress);
    return run?.status === 'failed' || (progress?.state === 'failed' &&
        (!run?.status || run.status === 'queued' || run.status === 'running'));
};

export const chatRequestFailureMessage = (error) => {
    const message = typeof error === 'string' ? error.trim().toLowerCase() : '';
    if (/offline|network error|not connected to the internet/.test(message)) {
        return 'Check your internet connection.';
    }
    if (/too many requests|rate limit/.test(message)) {
        return 'Too many requests. Please wait a moment.';
    }
    if (/sign(ed)? in|log in|unauthenticated/.test(message)) {
        return 'Sign in to continue.';
    }
    if (/temporarily unavailable|chat is unavailable/.test(message)) {
        return 'Chat is temporarily unavailable.';
    }
    if (/2,?000 characters/.test(message)) {
        return 'Keep your request under 2,000 characters.';
    }
    return 'Couldn’t complete your request.';
};

export const chatRequestResponseText = (run) => {
    const text = typeof run?.assistantText === 'string' ? run.assistantText.trim() : '';
    if (!text || !chatRequestFailed(run)) return text;
    const progress = normalizeChatV2Progress(run.progress);
    const error = run.error || (progress?.state === 'failed' ? progress.message : '');
    const failureCopy = [run.error, progress?.state === 'failed' ? progress.message : '',
        chatRequestFailureMessage(error), 'Chat could not complete. Please try again.',
        'Something went wrong. Please try again.', 'Something went wrong.', 'Unexpected Error'];
    return failureCopy.some((copy) => comparableText(copy) === comparableText(text)) ? '' : text;
};
